<template>
  <section
    v-if="props.data"
    class="advantages"
    :class="[ props.data.parentClasses, props.data.parentStyle ? props.data.parentStyle : 'defaultStyle' ]"
  >
    <div class="container">
      <div class="row justify-around">
        <div
          v-for="advantage in props.data.items"
          :key="advantage"
          class="col"
          :class="advantage.classes ? advantage.classes : 's6 m3 l3'"
        >
          <div class="value advantages__item valign-wrapper">
            <div
              v-if="advantage.image"
              class="advantages__item__img"
            >
              <nuxt-picture
                :img-attrs="{alt: advantage.title ? advantage.title : advantage.name}"
                :src="advantage.image"
                loading="lazy"
              />
            </div>

            <strong class="primary-color-text text-base-2 advantages__item__title">
              {{ advantage.title ? advantage.title : advantage.name }}
            </strong>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
/**
* Props
*/
const props = defineProps({
  data: {
    type: [Object],
    default: null
  }
})
</script>

<style lang="scss" scoped>
.advantages {
  padding: 2rem 0;
  margin: 0 auto;
  &__item {
    margin: 1rem auto;
    &__img {
      margin-right: 1.125rem;
      &:deep(img) {
        width: 50px;
        height: 50px;
        visibility: visible;
      }
    }
  }
}
</style>
